
import { Component, ViewChild } from '@angular/core';
import { OnInit, OnDestroy } from '@angular/core';
import { HelpService } from './help.service';
import { HelpDTO } from './help.dtos';
import { HelpElementResultComponent } from './helpElementResult.component';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store/AppState';
import { OverlayPanel } from 'primeng-lts/overlaypanel';
import { UserService } from '../../../user.service';
import { ActionDefinitionDTO } from '../../../api/plyca-dtos-v2';
import { ActionsProcessComponent } from '../../../actions/actions.process.component';
import { PlycaDataService } from '../../../../services/plyca.service';
import { DialogService, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { BaseComponent } from '../baseComponent/base.component';
import { NavigationEnd, Router } from '@angular/router';
import { catchError, filter, tap } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Component({
  selector: 'plyca-helpIndex',
  templateUrl: 'helpIndex.template.html'
})
export class HelpIndexComponent extends BaseComponent implements OnInit, OnDestroy {
  public searchText = '';
  help: HelpDTO;

  @ViewChild('resultPanel')
  public resultPanel: HelpElementResultComponent;
  @ViewChild('op')
  topNavHelpPanel: OverlayPanel;
  searching: boolean;


  constructor(
    public helpService: HelpService,
    public userService: UserService,
    public plycaService: PlycaDataService,
    public dialogService: DialogService,
    private router: Router,
    protected store: Store<AppState>
  ) {
    super();
    // limpiar ayuda contextual al navegar a un nuevo componente
    this.subscribe(router.events
      .pipe(filter(event => event instanceof NavigationEnd)),
      (event: NavigationEnd) => {
        if (this.topNavHelpPanel) {
          this.topNavHelpPanel.hide();
        }
      });
  }

  ngOnInit() { }

  ngOnDestroy() { }

  search(event, overlaypanel: OverlayPanel) {
    console.log('ABRIENDO AYUDA', this.searchText);
    let isSupportUser = this.userService.hasRoles('50');
    if (this.searchText) {
      if (isSupportUser && this.isProjectIdentifier(this.searchText)) {
        let identifier = this.getProjectIdentifier(this.searchText);
        this.router.navigate(['dossierInfo/' + identifier], {
        });

      } else if (isSupportUser && this.searchText.startsWith(':')) {
        let command = this.searchText.substring(1).trim().toUpperCase();


        this.subscribe(this.plycaService.getAction(command), (datos: any) => {
          if (datos && datos.content) {
            let actionDef = datos.content[0];
            if (actionDef) {
              this.execAction(actionDef);
            }
          }
        });
      } else {
        this.searching = true;
        this.resultPanel.groupedHelp = this.helpService.groupHelp([]);
        this.subscribe(
          this.helpService
            .searchByIndex(this.searchText).pipe(
              tap((help: HelpDTO) => {
                this.help = help;


                console.log('ayuda ejecutada', help, this.resultPanel);

                if (this.resultPanel) {
                  if (help) {
                    this.resultPanel.groupedHelp = this.helpService.groupHelp(help.content);
                  }
                  overlaypanel.show(event);


                }

                this.searching = false;
              }),
              catchError((error) => {
                this.searching = false;
                return throwError(error)
              })
            )
        );
      }
    }
  }

  isProjectIdentifier(command: string) {
    if (command == null) {
      return false;
    }
    command = command.trim();

    if (!command.startsWith('20')) {
      return false;
    }

    if (command.length !== 15 || command.charAt(4) !== '/' || command.split('/').length !== 2) {
      return false;
    }

    let year = command.substring(0, 4);
    let numericRest = command.substring(9);
    if (isNaN(Number(year)) || isNaN(Number(numericRest))) {
      return false;
    }

    return true;
  }

  getProjectIdentifier(command: string) {
    command = command.trim();
    return command.substring(0, 4) + command.substring(5);
  }

  execAction(actionDef: ActionDefinitionDTO) {

    let action = actionDef.executableAction;

    let config: DynamicDialogConfig = {
      header: action.name,
      width: '40%',
      styleClass: 'actionStyle',
      style: { overflow: 'hidden' }
    };
    config['action'] = action;

    return this.dialogService.open(ActionsProcessComponent, config);

  }
}
